import React from "react";
import Button from "react-bootstrap/Button";
import {FigureType} from "../../types/enums";
import {ListScoreFigureData} from "../../types/list";
import GeneFigure from "./GeneFigure";

const GeneQueryFigures = ({ginIds, selectedScreen, figData, onSwitchScreen}: {
  ginIds: string[];
  selectedScreen: string;
  figData: ListScoreFigureData;
  onSwitchScreen: (id: string) => void;
}) => (
  <>
    <div className="d-flex align-items-center justify-content-between mb-3">
      <h6 className="section-label border-info mb-0">Query Screens</h6>
      <div className="d-flex gap-1 flex-wrap">
        {ginIds.map(ginId => (
          <Button
            key={ginId}
            size="sm"
            variant={selectedScreen === ginId ? 'secondary' : 'outline-secondary'}
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => onSwitchScreen(ginId)}
          >
            {ginId}
          </Button>
        ))}
      </div>
    </div>
    <div className="row g-4">
      <div className="col-12 col-xl-6">
        <GeneFigure type={FigureType.ScoreAll} data={figData} labelClass="border-info"/>
      </div>
      <div className="col-12 col-xl-6">
        <GeneFigure type={FigureType.ScoreQuery} data={figData} labelClass="border-info"/>
      </div>
    </div>
  </>
);

export default GeneQueryFigures;